import * as insights from "./insights";

export const pansim = {
    ...insights,
}